import React from 'react'
import { View, Text } from '@react-pdf/renderer'
import { styles } from '../../Utilities/pdfExportStyles'
import {
    formatSenYenForPdf,
    priceFormatter,
    resolveDayPredictedSales,
    sumDisplayedHourlySenYen,
    sumHourlyStaffRequired,
    yenToSenYenOneDecimal
} from '../../Utilities/pdfExportUtils'

const PdfFooter = ({
    preds,
    predictedSales,
    nextPage,
    hoursWithStaffReq,
    HOURS,
    leftColWidth,
    hourlyEmpSalesPred,
    staffPerHour,
    totalActualStaff
}) => {
    // 合計 must compose from the same hourly values shown in this row — not a
    // separate day-level field that can diverge when customer_preds are missing.
    // Use nullish checks so an intentional day total of 0 is preserved.
    // Sum the *displayed* (1-decimal 千円) hour values so 合計 matches the row.
    const hours = HOURS || []
    const hasDisplayedHourlyPreds = hours.some(
        hour => preds?.[hour]?.pred_sales != null && preds[hour].pred_sales !== ''
    )
    const totalPredSalesSenYen = hasDisplayedHourlyPreds
        ? sumDisplayedHourlySenYen(preds, hours)
        : yenToSenYenOneDecimal(
              resolveDayPredictedSales(
                  predictedSales?.customer_predicted_sales,
                  predictedSales?.predicted_sales
              )
          )
    const totalStaffRequired = sumHourlyStaffRequired(preds, hours)

    return (
        <View break={nextPage} style={{ ...styles.table, margin: '0 auto 0 0', borderWidth: 0 }}>
            <View style={{ flexDirection: 'row' }}>
                <View style={{ flexDirection: 'column', width: leftColWidth }}>
                    <View
                        style={{
                            ...styles.tableColHeader,
                            width: '100%',
                            height: 20,
                            borderLeftWidth: 1
                        }}
                    >
                        <Text style={{ ...styles.tableCellHeader }}></Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text
                            style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}
                        ></Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>
                            予定 時間帯売上(千円)
                        </Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}>
                            Ａ
                        </Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>モデル 時間（h）</Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}>
                            Ｂ
                        </Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>予定 時間（h）</Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}>
                            Ａ-Ｂ
                        </Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>モデル差異（h）</Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            backgroundColor: '#E5E5E5',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text
                            style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}
                        ></Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>
                            実際 時間帯別売上(千円)
                        </Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            backgroundColor: '#E5E5E5',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}>
                            Ｃ
                        </Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>モデル時間（h）</Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            backgroundColor: '#E5E5E5',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}>
                            ＣーＡ
                        </Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>モデル差異（h）</Text>
                    </View>
                    <View
                        style={{
                            ...styles.tableCol,
                            width: '100%',
                            backgroundColor: '#E5E5E5',
                            height: 20,
                            borderLeftWidth: 1,
                            display: 'flex',
                            flexDirection: 'row'
                        }}
                    >
                        <Text
                            style={{ ...styles.tableCell, marginTop: '5px', marginLeft: '2px', width: '17.5%' }}
                        ></Text>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', width: '82.5%' }}>実績時間（h）</Text>
                    </View>
                </View>
                {hours.map(hour => {
                    const hourlyPredSales = priceFormatter(preds[hour]?.pred_sales)
                    const hourlyStaffReq = preds[hour]?.staff_required ? preds[hour].staff_required.toFixed(2) : 0.0
                    const hourlyActualStaff = staffPerHour[hour] ? ((staffPerHour[hour] * 10) / 10).toFixed(2) : 0.0
                    const hourlyDiff = (((hourlyStaffReq - hourlyActualStaff) * 10) / 10).toFixed(2)
                    return (
                        <View key={hour} style={{ flexDirection: 'column' }}>
                            <View
                                style={{
                                    ...styles.tableColHeader,
                                    width: '19.0px',
                                    height: 20
                                }}
                            >
                                <Text style={{ ...styles.tableCellHeader, marginTop: '5px' }}>{hour}</Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                                    {hourlyPredSales}
                                </Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                                    {hourlyStaffReq === 0 ? '0.00' : hourlyStaffReq}
                                </Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                                    {hourlyActualStaff === 0 ? '0.00' : hourlyActualStaff}
                                </Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                                    {hourlyDiff}
                                </Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                            </View>
                            <View style={{ ...styles.tableCol, width: '19.0px', height: 20 }}>
                                <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                            </View>
                        </View>
                    )
                })}
                <View style={{ flexDirection: 'column' }}>
                    <View style={{ ...styles.tableColHeader, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCellHeader, marginTop: '5px' }}>合計</Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                            {formatSenYenForPdf(totalPredSalesSenYen)}
                        </Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                            {totalStaffRequired ? totalStaffRequired.toFixed(2) : hoursWithStaffReq?.fullCount}
                        </Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'right' }}>
                            {((totalActualStaff * 10) / 10).toFixed(2)}
                        </Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px' }}>{'-'}</Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                    </View>
                    <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                        <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                    </View>
                </View>
            </View>
            <View style={{ alignItems: 'flex-end' }}>
                <View style={{ flexDirection: 'row' }}>
                    <View style={{ flexDirection: 'column' }}>
                        <View
                            style={{
                                ...styles.tableCol,
                                width: '68.8px',
                                height: 20,
                                backgroundColor: '#E5E5E5',
                                borderLeftWidth: 1
                            }}
                        >
                            <Text style={{ ...styles.tableCell, marginTop: '5px' }}>予定人時売上高</Text>
                        </View>
                        <View
                            style={{
                                ...styles.tableCol,
                                width: '68.8px',
                                height: 20,
                                backgroundColor: '#E5E5E5',
                                borderLeftWidth: 1
                            }}
                        >
                            <Text style={{ ...styles.tableCell, marginTop: '5px' }}>実績人時売上高</Text>
                        </View>
                        <View
                            style={{
                                ...styles.tableCol,
                                width: '68.8px',
                                height: 20,
                                backgroundColor: '#E5E5E5',
                                borderLeftWidth: 1
                            }}
                        >
                            <Text style={{ ...styles.tableCell, marginTop: '5px' }}>差異</Text>
                        </View>
                    </View>
                    <View style={{ flexDirection: 'column' }}>
                        <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                            <Text style={{ ...styles.tableCell, marginTop: '5px', alignItems: 'center' }}>
                                {hourlyEmpSalesPred || ''}
                            </Text>
                        </View>
                        <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                            <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                        </View>
                        <View style={{ ...styles.tableCol, width: '46px', height: 20 }}>
                            <Text style={{ ...styles.tableCell, marginTop: '5px' }}></Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}

export default PdfFooter
